import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';

export const NotFound: React.FC = () => {
  return (
    <div className="app-container">
      <Header />
      <main style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '6rem', margin: 0, color: 'var(--muted-foreground)', opacity: 0.5 }}>404</h1>
        <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Page Not Found</h2>
        <p style={{ color: 'var(--muted-foreground)', marginBottom: '2rem', maxWidth: '500px' }}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link 
          to="/" 
          style={{ 
            padding: '0.75rem 1.5rem', 
            background: 'var(--primary)', 
            color: 'var(--primary-foreground)', 
            borderRadius: '6px', 
            textDecoration: 'none',
            fontWeight: 600
          }}
        >
          Back to Dashboard
        </Link>
      </main>
    </div>
  );
};

